import classNames from 'classnames';
import colorContrast from 'font-color-contrast';
import {bool} from 'prop-types';
import React, {useContext} from 'react';
import {
  BACKGROUND_TYPE_BLUR,
  BACKGROUND_TYPE_COLOR,
  getOverlayColor,
} from '../../../../helpers/style-background';
import {PokeContext, PokeStateContext} from '../../context';
import './_Styles.scss';

const propTypes = {
  withoutOverflow: bool,
  isNotCardElem: bool,
};

const ClickableBlockOverlay = ({
  withoutOverflow = false,
  withoutBottomOverflow = false,
  isNotCardElem = false,
  style: propStyle = {},
  colorToUse = null,
}) => {
  const {poke, sendBlockHovered} = useContext(PokeContext) ?? {};
  const {inBuilder = false} = useContext(PokeStateContext);

  let contrast = '#000000';

  const {style} = poke ?? {};
  const {background, backgroundColor, overlay, margin} = style ?? {};
  const overlayColor = getOverlayColor(overlay);

  if (inBuilder === false && isNotCardElem !== true) {
    return <></>;
  }
  if (colorToUse != null) {
    contrast = colorContrast(colorToUse?.slice(0, 7));
  } else if (isNotCardElem) {
    if (overlayColor != null) {
      const alpha = parseInt(overlayColor.slice(7, 9) || 'FF', 16) / 255;
      contrast = colorContrast(alpha > 0.5 ? '#000000' : '#FFFFFF');
    }
  } else {
    if (backgroundColor != null) {
      contrast = colorContrast(backgroundColor);
    } else if (
      poke.style?.background?.type === BACKGROUND_TYPE_COLOR ||
      poke.style?.background?.type === BACKGROUND_TYPE_BLUR
    ) {
      contrast = colorContrast(background?.primaryColor?.slice(0, 7));
    }
  }

  return (
    <div
      className={classNames('clickable-block-overlay', {
        'without-overflow': withoutOverflow,
        'without-bottom-overflow': withoutBottomOverflow,
        'is-not-card-elem': isNotCardElem,
      })}
      style={{
        borderColor: contrast,
        ...(margin != null && isNotCardElem === true
          ? {margin: `${margin}px`}
          : {}),
        ...propStyle,
      }}
      onMouseEnter={() => sendBlockHovered?.(true)}
      onMouseLeave={() => sendBlockHovered?.(false)}
    />
  );
};

ClickableBlockOverlay.propTypes = propTypes;

export default ClickableBlockOverlay;
